import { render, staticRenderFns } from "./BgGreyInput.vue?vue&type=template&id=6d55826c&scoped=true"
import script from "./BgGreyInput.vue?vue&type=script&lang=js"
export * from "./BgGreyInput.vue?vue&type=script&lang=js"
import style0 from "./BgGreyInput.vue?vue&type=style&index=0&id=6d55826c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d55826c",
  null
  
)

export default component.exports